import { DocumentType } from "@telarya/telarya-sdk"

export const StepTelarTypeToDocumentTypes = {
  Pickup: {
    ShippingContainer: [
      {
        documentType: DocumentType.PictureContainerNumber,
        isRequired: true
      },
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: false
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: false
      },
      {
        documentType: DocumentType.PictureVisualInspection,
        isRequired: false
      },
      {
        documentType: DocumentType.DocumentEir,
        isRequired: false
      }
    ],
    Trailer: []
  },
  Load: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: false
      }
    ]
  },
  Unload: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: false
      }
    ]
  },
  Weighing: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentWeighingResult,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentWeighingResult,
        isRequired: false
      }
    ]
  },
  Customs: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      }
    ]
  },
  Scan: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      }
    ]
  },
  PhysicalScan: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      },
      {
        documentType: DocumentType.PictureContainerSealNumber,
        isRequired: true
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentCmr,
        isRequired: true
      }
    ]
  },
  Dropoff: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentEir,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentEir,
        isRequired: false
      }
    ]
  },
  Documents: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentAny,
        isRequired: true
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentAny,
        isRequired: true
      }
    ]
  },
  Fumigation: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentAny,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentAny,
        isRequired: false
      }
    ]
  },
  Inspection: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentInspectionResult,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentInspectionResult,
        isRequired: false
      }
    ]
  },
  VehiclePickup: {
    ShippingContainer: [
      {
        documentType: DocumentType.PictureVehicleLicensePlate,
        isRequired: true
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.PictureVehicleLicensePlate,
        isRequired: true
      }
    ]
  },
  VehicleDropoff: {
    ShippingContainer: [
      {
        documentType: DocumentType.PictureVehicleLicensePlate,
        isRequired: true
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.PictureVehicleLicensePlate,
        isRequired: true
      }
    ]
  },
  Parking: {
    ShippingContainer: [
      {
        documentType: DocumentType.PictureVisualInspection,
        isRequired: true
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.PictureVisualInspection,
        isRequired: true
      }
    ]
  },
  Waypoint: {
    ShippingContainer: [
      {
        documentType: DocumentType.DocumentAny,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.DocumentAny,
        isRequired: false
      }
    ]
  },
  Buy: {
    ShippingContainer: [
      {
        documentType: DocumentType.PurchaseInvoice,
        isRequired: false
      }
    ],
    Trailer: [
      {
        documentType: DocumentType.PurchaseInvoice,
        isRequired: false
      }
    ]
  }
}
